export default "__VITE_ASSET__DXVoP7U5__"